import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  inject,
} from "@angular/core";
import {AsyncPipe} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import type {WorksModel} from "src/app/models/WorksModel";
import type {User} from "src/app/modules/auth/models/User";
import {WorkSelectionService} from "../../../lists/services/work-selection.service";
import {WorkSelectionActionsComponent} from "../../../lists/components/work-selection-actions/work-selection-actions.component";
import type {WorkSelectionActionCompletion} from "../../../lists/interfaces/work-selection.interface";
import type {WorkUpdate} from "../../../shared/interfaces/WorkUpdate.interface";
import type {WorkModalNavigationContext} from "../../../shared/interfaces/work-modal-navigation.interface";
import {WorkCardComponent} from "../../../works/components/work-card/work-card.component";

@Component({
  selector: "app-catalog-search-results",
  templateUrl: "./catalog-search-results.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    TranslateModule,
    WorkCardComponent,
    WorkSelectionActionsComponent,
  ],
  providers: [WorkSelectionService],
})
export class CatalogSearchResultsComponent implements OnChanges {
  @Input() works: WorksModel[] = [];
  @Input() user!: User;
  @Input() isMobile = false;
  @Input() libraryOnly = false;
  @Input() active = false;
  @Input() scope = "";
  @Input() hasMultipleTypes = false;
  @Input() modalNavigationContext!: WorkModalNavigationContext;
  @Output() workUpdated = new EventEmitter<WorkUpdate>();
  readonly selection = inject(WorkSelectionService);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["scope"] || !this.active) this.selection.clear();
    if (changes["works"]) {
      this.selection.reconcile(this.works);
      this.selection.updateWorks(this.works);
    }
  }

  onBulkSuccess(completion: WorkSelectionActionCompletion): void {
    if (completion.removesFromSource) {
      this.selection.removeSuccesses(completion.references);
      for (const reference of completion.references) {
        this.workUpdated.emit({
          work: reference._id,
          type: reference.type,
          operator: "remove",
          local: true,
          eventName: "workLocallyUpdated",
        });
      }
    } else if (completion.updatedWorks) {
      this.selection.updateWorks(completion.updatedWorks);
    }
  }
}
